<template>
    <b-form-row class="mb-1 mt-1">
        <b-col>
            {{ deal.title }}
        </b-col>
        <b-col cols="3">
            <div class="text-right">{{Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(deal.amount) }}</div>
        </b-col>
        <b-col cols="1">
            <input type="hidden" v-model="deal.id"/>
            <b-button variant="outline" size="sm" v-on:click="removeItem">
                <b-icon-x aria-hidden="true"></b-icon-x>
            </b-button>
        </b-col>
    </b-form-row>
</template>

<script>
    export default {
        name: "DealListEntry",
        props: ["deal"],
        methods: {
            removeItem() {
                this.$emit('removeItem', this.deal.id);
            }
        }
    }
</script>

<style scoped>

</style>